<template>
  <div>
    <ValidationProvider rules="required" ref="topOffPlan" v-slot="{ errors }">
    <b-form class="needs-validation"
           >
      <b-row>
        <b-col xl="3" lg="3" sm="3">
          <p class="mt-3">
            <span class="h3">Name</span>
          </p>
        </b-col>
        <b-col xl="9" lg="9" sm="9">
          <b-form-group
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              :state="nameStatus"
              v-model="mobileDataPlansForm.name"
              placeholder="ex.10MB Renews Monthly"
            ></b-form-input>
            <b-form-invalid-feedback :state="nameStatus">
              Please enter a valid plan name.
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="3" lg="3" sm="3">
          <p class="mt-3">
            <span class="h3">Description</span>
          </p>
        </b-col>
        <b-col xl="9" lg="9" sm="9">
          <b-form-group
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              :state="descriptionStatus"
              v-model="mobileDataPlansForm.description"
              placeholder="ex. 10MB Renews Data Monthly"
            ></b-form-input>
            <b-form-invalid-feedback :state="descriptionStatus">
              Please enter valid description
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="3" lg="3" sm="3">
          <p class="mt-3">
            <span class="h3">Price Type</span>
          </p>
        </b-col>
        <b-col xl="9" lg="9" sm="9">
          <b-form-group label-for="input-1">
            <b-form-select
              id="period"
              v-model="mobileDataPlansForm.price"
              :options="priceTypeOption"
              :state="priceStatus"
              value-field="key"
              class="mt-2"
              text-field="label"
            ></b-form-select>
            <b-form-invalid-feedback :state="priceStatus">
              Please enter a valid price type.
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="3" lg="3" sm="3">
          <p class="mt-3">
            <span class="h3">Unit of Measure</span>
          </p>
        </b-col>
        <b-col xl="9" lg="9" sm="9">
          <b-form-group
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              :state="unitStatus"
              v-model="mobileDataPlansForm.unit"
              placeholder="ex. 1000000b"
            ></b-form-input>
            <b-form-invalid-feedback :state="unitStatus">
              Please enter a valid Unit of Measure
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="3" lg="3" sm="3">
          <p class="mt-3">
            <span class="h3">Recurring Charge Period</span>
          </p>
        </b-col>
        <b-col xl="9" lg="9" sm="9">
          <b-form-group label-for="input-1">
            <b-form-select
              id="period"
              v-model="mobileDataPlansForm.recurringPeriod"
              :options="chargeOption"
              :state="recurringPeriodStatus"
              value-field="key"
              class="mt-2"
              text-field="label"
            ></b-form-select>
            <b-form-invalid-feedback :state="recurringPeriodStatus">
              Please enter a valid recurring charge period.
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="3" lg="3" sm="3">
          <p class="mt-3">
            <span class="h3">Start Date Period</span>
          </p>
        </b-col>
        <b-col xl="9" lg="9" sm="9">
          <b-form-group
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              :state="startPeriodStatus"
              v-model="mobileDataPlansForm.startPeriod"
            ></b-form-input>
            <b-form-invalid-feedback :state="startPeriodStatus">
              Please enter a valid start date period.
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="3" lg="3" sm="3">
          <p class="mt-3">
            <span class="h3">End Date Period</span>
          </p>
        </b-col>
        <b-col xl="9" lg="9" sm="9">
          <b-form-group
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              :state="true"
              v-model="mobileDataPlansForm.endPeriod"
              placeholder="Ex. 2030-10-12T12:50:00Z or nothing"
            ></b-form-input>
            <b-form-invalid-feedback :state="true">
              Please enter a end date period.
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="3" lg="3" sm="3">
          <p class="mt-3">
            <span class="h3">Redirect Server IP Period</span>
          </p>
        </b-col>
        <b-col xl="9" lg="9" sm="9">
          <b-form-group
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              :state="serverPeriodStatus"
              v-model="mobileDataPlansForm.serverPeriod"
            ></b-form-input>
            <b-form-invalid-feedback :state="serverPeriodStatus">
              Please enter a valid redirect server IP period.
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <hr>
      <div class="mt-3 d-flex justify-content-between">
        <base-button type="white" title="Close"  v-on:click="modalClose()">
          Close
        </base-button>
        <base-button type="primary" title="Search"  v-on:click="mobileDataPlanSubmit" :loading="submitLoading">
          Submit
        </base-button>
      </div>
    </b-form>
    </ValidationProvider>

  </div>
</template>

<script>
    import administratorService from "../../common/api-services/administrator-service";
    import handleResponse from "../../common/directive/handlResponse";
    import {ValidationProvider} from "vee-validate";
    export default {
        name: "mobile-data-plan",
        components: {
          ValidationProvider
        },
      computed: {
        nameStatus() {
          return this.mobileDataPlansForm.name.length > 0
        },
        descriptionStatus() {
          return this.mobileDataPlansForm.description.length > 0
        },
        priceStatus() {
          return this.mobileDataPlansForm.price.length > 0
        },
        unitStatus() {
          return this.mobileDataPlansForm.unit.length > 0
        },
        recurringPeriodStatus() {
          return this.mobileDataPlansForm.recurringPeriod.length > 0
        },
        startPeriodStatus() {
          return this.mobileDataPlansForm.startPeriod.length > 0
        },
        serverPeriodStatus() {
          return this.mobileDataPlansForm.serverPeriod.length > 0
        },
      },
      data() {
        return {
          mobileDataPlansForm: {
            name: '',
            description: '',
            price: '',
            unit: '',
            recurringPeriod: '',
            startPeriod: '1999-10-12T12:50:00Z',
            endPeriod: '',
            serverPeriod: '10.57.1.47'
          },
          priceTypeOption: [
            {key: 'recurring', label: 'recurring'},
            {key: 'usage', label: 'usage'}
          ],
          chargeOption: [
            {key: 'yearly', label: 'yearly'},
            {key: 'monthly', label: 'monthly'},
            {key: 'weekly', label: 'weekly'},
            {key: 'daily', label: 'daily'}
          ],
          editStatus: false,
          submitLoading: false
        }
      },
      mounted() {
        this.$root.$on('editTopOffPlan', (res => {
          this.editStatus = res.status;
          this.fetchTopOffPlan(res.item)
        }))
      },
      methods: {
        fetchTopOffPlan(item) {
          this.mobileDataPlansForm.type = item.type;
          this.mobileDataPlansForm.name = item.name;
          this.mobileDataPlansForm.description = item.description;
          this.mobileDataPlansForm.price = item.price;
          this.mobileDataPlansForm.speed = item.speed;
          this.mobileDataPlansForm.quota = item.quota;
          this.mobileDataPlansForm.expires = item.quota;
          this.mobileDataPlansForm.expires = item.expires;
          this.mobileDataPlansForm.amount = item.amount;
          this.mobileDataPlansForm.units = item.units;
        },

        modalClose() {
          this.$bvModal.hide('mobile-data-plan');
        },

        mobileDataPlanSubmit() {
          if (this.nameStatus && this.descriptionStatus && this.priceStatus && this.unitStatus && this.recurringPeriodStatus &&
            this.startPeriodStatus && this.serverPeriodStatus) {
              this.submitLoading = true;
            this.topOffPlanFunc();
          }
        },

        topOffPlanFunc() {
          administratorService.addDataPlans(this.mobileDataPlansForm).then(res => {
            this.submitLoading = false;
            let {type, msg} = handleResponse.apiResponse(res);
            this.$toast(JSON.stringify(msg), {type: type})
            this.modalClose();
            this.$root.$emit('manageMobileDataPlan', true)
          })
        },
      }
    }
</script>

<style scoped>

</style>
